import React from 'react';
import { connect } from 'react-redux';
import { removeAlert, addAlert } from 'store/actions/alertActions';

const Sound = props => {
  const { audioUrl } = props;
  const handleAudioPlay = e => {
    e.stopPropagation();
    props.addAlert({ url: audioUrl });
  };

  return (
    <>
      <div className="sound-icon">
        <i onClick={handleAudioPlay} style={{ fontSize: 18 }} className="fa fa-volume-down"></i>
      </div>
    </>
  );
};

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = {
  removeAlert,
  addAlert
};

export default connect(mapStateToProps, mapDispatchToProps)(Sound);
